import { Box, Grid, Typography } from "@mui/material";
import styles from "./HomeNew.module.css";
import home_images from "../../assets/images/AI Home.jpg";

const Vision = () => {
  return (
    <Box className={styles.employer_details}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box>
          <img
            src={home_images}
            alt=""
            width="100%"
            style={{ marginTop: "20px" }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ padding: "20px 10px 75px 20px", backgroundColor: "#f2f6f7" }}
      >
        <Box>
          <Typography sx={{ fontSize: "17px !important" }}>
            <b>Our Vision</b>
          </Typography>
          <Typography sx={{ fontSize: "16px !important", marginTop: "10px" }}>
            We envision a future where hiring is effortless, efficient, and
            transparent. By leveraging advanced technology and innovative
            solutions, we strive to create an environment where organizations
            can connect with the right talent quickly and effectively.
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
};

export default Vision;
